import auditNoteByFile from "./auditNoteByFile";
import auditByFile from "./auditByFile";
import finding from "./finding";
import masterDataByFile from "./masterDataByFile";
import entityByFile from "./entityByFile";
import transactionsByFile from "./transactionsByFile";
import findingRuleByFile from "./findingRuleByFile";
import genericOverview from "./genericOverview";
import auditSummaryByFile from "./auditSummaryByFile";
import findingsSchemaWithoutFiscalYear from "./findingsSchemaWithoutFiscalYear";
import genericReportsByFile from "./genericReportsByFile";
import customReportConfiguration from "./customReportConfiguration";
import customReport from "./customReport";
import repository from "./repository";
import submissionSaft from "./submissionSaft";
import newGeneration from "./newGeneration";
import importProfiles from "./importProfiles";
import dataSyncLog from "./dataSyncLog";
import {
    BarChart,
    CloudSync,
    Dashboard,
    ShowChart,
    Task,
    StackedLineChart,
    SettingsSuggest,
    Topic,
} from "mosaic-react-icons";
import rawData from "./rawData";
import customCsvRawData from "./customCsvRawData";
import structuredData from "./structuredData";
import columnMappingFlow from "./columnMappingFlow";
import mappingOverview from "./mappingOverview";
import importProfilesMapping from "./importProfilesMapping";
import translationTablesMapping from "./translationTablesMapping";
import mappingRunHistory from "./mappingRunHistory";
import dataChangeHistory from "./dataChangeHistory";
import { filterOverviewMenuForNewNavigation } from "../utils/filterOverviewMenuForNewNavigation";
const SHOW_TRANSLATION_TABLES_MENU_ENTRY = false;

let navigation = [];

const menuRouting = {
    saft_dk: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_dk",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_dk" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_dk)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 3,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftDkGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_dk)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_dk",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 4,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftDkGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAF-T DK)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftDkGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftDkGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_dk" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_dk" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_dk" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_dk" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_dk: [
        {
            level: 0,
            priority: 2,
            name: "label(Source Data Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_dk",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_dk" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_dk)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvDkGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvDkGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_dk)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_dk" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_dk" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_dk" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_dk" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_dk",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_dk",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_lt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_lt",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_lt" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_lt)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftLtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_lt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_lt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftLtGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAF-T LT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftLtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftLtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lt" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lt" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_lt: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T LT Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_lt",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_lt" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_lt)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T LT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvLtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvLtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_lt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lt" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lt" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_pl: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pl",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_pl" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_pl)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            navigation: "prop(saftPlGenericMenuAudit)",
            isToBuildMenu: true,
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_pl)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pl",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftPlGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal JPK)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftPlGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftPlGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pl" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pl" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pl" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pl" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_pl: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T PL Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_pl",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_pl" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_pl)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T PL)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvPlGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvPlGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_pl)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pl" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pl" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pl" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pl" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pl",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pl",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_fr: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_fr",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_fr" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_fr)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftFrGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_fr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_fr",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftFrGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-FR)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftFrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftFrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_fr: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T FR Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_fr",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_fr" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_fr)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T FR Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvFrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvFrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_fr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_fr" },
                    true,
                    { allowWithoutAvailableFilters: true },
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    {},
                    false,
                    { allowWithoutAvailableFilters: true },
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_fr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_fr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_no: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_no",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_no" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_no)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftNoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_no)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_no",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftNoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-NO)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftNoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftNoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_no" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_no" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_no" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_no" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_no: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T NO Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_no",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_no" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_no)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T NO Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvNoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvNoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_no)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_no" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_no" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_no" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_no" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_no",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_no",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_ro: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_ro",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_ro" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_ro)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftRoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_ro)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_ro",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftRoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-RO)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftRoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftRoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ro" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ro" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ro" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ro" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ro: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T RO Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_ro",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_ro" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_ro)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T RO Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvRoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvRoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ro)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ro" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ro" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ro" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ro" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ro",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ro",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_mx: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_mx",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_mx" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_mx)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftMxGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_mx)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_mx",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftMxGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(E-Accounting)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftMxGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftMxGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_mx" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_mx" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_mx" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_mx" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_bg: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_bg",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_bg" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_bg)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftBgGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_bg)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_bg",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftBgGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-BG)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftBgGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftBgGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_bg" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_bg" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_bg" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_bg" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_bg: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T BG Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_bg",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_bg" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_bg)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T BG Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvBgGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvBgGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_bg)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_bg" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_bg" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_bg" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_bg" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_bg",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_bg",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_at: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_at",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_at" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_at)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftAtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_at)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_at",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftAtGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_at)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_at",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-AT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftAtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftAtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_at" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_at" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_at" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_at" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_at)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_at)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_at)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_at)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_at",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_at",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_at: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T AT Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_at",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_at" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_at)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T AT Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvAtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvAtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_at)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_at" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_at" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_at" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_at" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_at)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_at)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_at)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_at)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_at",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_at",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_lu: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_lu",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_lu" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_lu)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftLuGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_lu)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_lu",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftLuGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lu)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lu",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT-LU)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftLuGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftLuGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lu" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lu" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lu" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_lu" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lu)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lu)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lu)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lu)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lu",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lu",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_lu: [
        {
            level: 0,
            priority: 1,
            name: "label(Source SAF-T LU Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_lu",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_lu" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_lu)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source SAF-T LU Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvLuGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvLuGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_lu)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lu" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lu" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lu" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_lu" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lu)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lu)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lu)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lu)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lu",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lu",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    erp_pt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/erp_pt",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(erp_pt)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(erpPtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(erp_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "erp_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(ERP PT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(erpPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(erpPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "erp_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "erp_pt" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "erp_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "erp_pt" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "erp_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "erp_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    custom_report: [
        {
            level: 0,
            priority: 3,
            name: "label(Custom Reports)",
            //Quick fix to saft_pt (use only in PT), need other approach
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pt/custom_reports",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/custom_reports",
            exact: true,
            icon: ShowChart,
            routing: [
                // New Navigation
                customReport(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/custom_reports/:id?",
                    navigation,
                    true,
                    "label(Custom Report)",
                    { modulePrefix: "saft_pt" },
                    true
                ),
                // New Navigation
                customReport(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/custom_reports/:id?",
                    navigation,
                    true,
                    "label(Custom Report)",
                ),
            ],
        },
    ],
    saft_pt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pt",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_pt" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_pt)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftPtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftPtGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT_PT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pt" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_pt" },
                    true,
                ),
                // New Navigation

                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_pt: [
        {
            name: "label(Source SAF-T PT Data)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pt" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pt" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_pt" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_cv: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_cv",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_cv" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_cv)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftCvGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_cv)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftCvGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(Legal SAFT_CV)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftCvGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftCvGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_cv" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_cv" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_cv" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_cv" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    generic_generator: [
        {
            level: 0,
            priority: 101,
            name: "label(File Generation)",
            to: "/:projectId/:fiscalYear/:importId/repository/generation",
            icon: SettingsSuggest,
            isToBuildMenu: true,
            navigation: [],
            routing: [
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(generation)",
                    navigation,
                    true,
                ),
            ],
            queries: [],
        },
    ],
    repository: [
        {
            level: 0,
            priority: 100,
            name: "label(Repository)",
            to: "/:projectId/:fiscalYear/:importId/repository/activity",
            icon: CloudSync,
            isToBuildMenu: true,
            navigation: [],
            routing: [
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:urlRedir(redirect)",
                    navigation,
                ),
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(generation)",
                    navigation,
                    true,
                ),
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section(generation)",
                    navigation,
                    false,
                ),
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(merge_collisions)",
                    navigation,
                ),
                submissionSaft(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(submission_saft)",
                    navigation,
                ),
                importProfiles(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section(import_profiles)",
                    navigation,
                ),
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/merge_collisions",
                    navigation,
                ),
                customReportConfiguration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(custom_reports_by_project)",
                    navigation,
                    false,
                    true,
                    true,
                ),
                customReportConfiguration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section(custom_reports_by_project)",
                    navigation,
                    false,
                    true,
                    true,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section(activity)",
                    navigation,
                    true,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section/:id",
                    navigation,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section?",
                    navigation,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section?",
                    navigation,
                ),

                findingsSchemaWithoutFiscalYear(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/:section(audit_findings)",
                    navigation,
                    true,
                    "label(Findings)",
                ),

                finding(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/:section(audit_findings)/:id",
                    navigation,
                    true,
                    "label(Finding)",
                ),
            ],
            queries: [],
        },
    ],
    pt_mod_10: [
        {
            name: "label(Modelo 10)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(ptMod10GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(ptMod10GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(pt_mod_10)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_mod_10" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_mod_10" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_mod_10" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_mod_10" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_mod_10",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_mod_10",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    pt_dmr: [
        {
            name: "label(Source DMR PT)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(ptDmrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(ptDmrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(pt_dmr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_dmr" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_dmr" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_dmr" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "pt_dmr" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_dmr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_dmr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    adds: [
        {
            name: "label(additional_datasets)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(addsGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(addsGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(adds)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "adds",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "adds",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_ao: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_ao",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "saft_ao" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_ao)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftAoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_ao)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_ao",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftAoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(legal saft_ao)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftAoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftAoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                // New Navigation
                structuredData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entitiesMenu(structured_data)",
                    navigation,
                    true,
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ao" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ao" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ao" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "saft_ao" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ao_m2: [
        {
            level: 0,
            priority: 1,
            name: "label(Source Data Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_ao_m2",
            toNewNavigation: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/overview",
            exact: true,
            icon: Dashboard,
            routing: [
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/overview",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                    { modulePrefix: "csv_ao_m2" },
                    true,
                ),
                // New navigation
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_ao_m2)?",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source Modelo 2 AO)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvAoM2GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvAoM2GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ao_m2)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m2" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m2" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m2" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m2" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m2",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m2",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ao_m_7: [
        {
            name: "label(Source Modelo 7 AO)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvAoM7GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvAoM7GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ao_m_7)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_7" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_7" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_7" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_7" },
                    true,
                ),
                // New Navigation
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_7)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m_7",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m_7",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ao_m_1: [
        {
            name: "label(Source Modelo 1 AO)",
            icon: StackedLineChart,
            useInMenuTreeList: true,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvAoM1GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvAoM1GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ao_m_1)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_1" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_1" },
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_1" },
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                    { modulePrefix: "csv_ao_m_1" },
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/transactional_data/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m_1)/transactional_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m_1",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    subEntity: "transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m_1",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    raw_data: [
        {
            level: 0,
            priority: 3,
            name: "label(RAW DATA)",
            icon: Topic,
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix?/raw_data/:entityRawData",
            routing: [
                rawData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix?/raw_data/:entityRawData?",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [],
        },
    ],
    custom_templates: [
        {
            level: 0,
            priority: 3,
            name: "label(Custom Templates Raw Data)",
            icon: Topic,
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/custom_templates/:entityRawData",
            routing: [
                customCsvRawData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(custom_templates)/:entityRawData?",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 4,
            name: "label(Import Mapping)",
            icon: Dashboard,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Import Profiles)",
                    to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/import_profiles",
                },
                {
                    level: 1,
                    name: "label(Mapping Overview)",
                    to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/mapping_overview",
                },
                ...(SHOW_TRANSLATION_TABLES_MENU_ENTRY
                    ? [{
                        level: 1,
                        name: "label(Translation Tables)",
                        to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/translation_tables",
                    }]
                    : []),
                {
                    level: 1,
                    name: "Data sync log",
                    to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/data_sync_log",
                },
                {
                    level: 1,
                    name: "label(Data Change History)",
                    to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/data_change_history",
                },
            ],
            routing: [
                mappingOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/mapping_overview",
                    navigation,
                    true,
                    "label(Mapping Overview)",
                ),
                importProfilesMapping(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/import_profiles",
                    navigation,
                    true,
                    "label(Import Profiles)",
                ),
                columnMappingFlow(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(column_mapping)/:entityRawData?",
                    navigation,
                ),
                translationTablesMapping(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/translation_tables",
                    navigation,
                    true,
                    "label(Translation Tables)",
                ),
                mappingRunHistory(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/run_history",
                    navigation,
                    true,
                    "label(Mapping Run History)",
                ),
                dataSyncLog(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/data_sync_log",
                    navigation,
                    true,
                    "Data sync log",
                ),
                dataSyncLog(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/run_history/data_sync_log",
                    navigation,
                    true,
                    "Data sync log",
                ),
                dataChangeHistory(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/import_mapping/data_change_history",
                    navigation,
                    true,
                    "label(Data Change History)",
                ),
            ],
            queries: [],
        },
    ],
};

const filteredQueriesByModules = (modules) => {
    if (modules && modules.length > 0) {
        const filteredRoutes = (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            const queries = (menuArray || [])
                .filter((elem) => elem.queries !== undefined)
                .map(({ queries }) => {
                    return queries;
                });
            acc.push(...queries);
            return acc;
        }, []);
        return filteredRoutes.flat();
    }
    return [];
};

const filteredQueriesByModulesForMenu = (modules) => {
    if (modules && modules.length > 0) {
        return (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            const queries = (menuArray || [])
                .filter((elem) => elem.isToBuildMenu && elem.queries !== undefined)
                .map(({ queries }) => {
                    return queries;
                });

            acc.push({ [`${elem}`]: queries.flat() });
            return acc;
        }, []);
    }
    return [];
};

const filteredNavigationByModules = (modules) => {
    let filteredRoutes = [];
    if (modules && modules.length > 0) {
        const reorderedArray = reorderRouting(modules);

        const filteredArray = filterOverviewMenuForNewNavigation(modules, reorderedArray);

        iterateNavigation(filteredArray, filteredRoutes);
    }
    return filteredRoutes;
};

const reorderRouting = (modules) => {
    if (modules && modules.length > 0) {
        const filteredRoutes = (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            if (menuArray) {
                acc.push(...menuArray);
            }
            return acc;
        }, []);
        return filteredRoutes.sort(function (a, b) {
            return a.priority - b.priority;
        });
    }
    return [];
};


const getFirstModuleOfArray = (modules) => {
    if (modules && modules.length > 0) {
        const firstModule = Object.keys(menuRouting).find(
            (element) => modules.indexOf(element) >= 0,
        );
        return firstModule || "";
    }
    return [];
};

const filteredRoutesByModules = (modules) => {
    let filteredRoutes = [];
    if ((modules || []).length !== 0) {
        const reorderedArray = reorderRouting(modules);

        // Filter menu items only (hide Data, CSV Overview, etc.) but keep all routes
        const filteredArray = filterOverviewMenuForNewNavigation(modules, reorderedArray);

        navigation.splice(0, navigation.length, ...constructMenu(filteredArray)); //prevent navigation to duplicate entries
        iterateRouting(reorderedArray, filteredRoutes); // Use FULL array for routes
    }

    return filteredRoutes.flat();
};

const constructMenu = (reorderedArray) => {
    const navigationContent = reorderedArray.map(({ routing, queries, ...restNavigation }) => {
        return restNavigation;
    });
    return [...navigationContent];
};

const iterateNavigation = (navigation, arrayOfNavigations) => {
    arrayOfNavigations.push(...navigation);
};

const iterateRouting = (navigation, arrayOfNavigations) => {
    const mergeTo = navigation.map(({ routing, queries, ...restNavigation }) => {
        if (restNavigation && Array.isArray(restNavigation)) {
            iterateRouting(restNavigation, arrayOfNavigations);
        }
        return routing || [];
    });
    arrayOfNavigations.push(...(mergeTo.flat() || []));
};

export {
    menuRouting,
    filteredQueriesByModules,
    filteredRoutesByModules,
    filteredNavigationByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
};
